import { getBackendUrl } from "@Utils";
import { useTranslation } from "@i18n";
import { useEffect, useState } from "react";
import IconComponent from "@CubeComponents/icons";
import TextFieldComponent from "@CubeComponents/Mui_Form/TextFieldComponent";
import ButtonComponent from "@CubeComponents/form/ButtonComponent";
import DesignViewerLayoutSettingComponent from "./SettingComponent";
import axiosWrapper from "@Services/axiosWrapper";
import type { UpdateViewResponse } from "@ServerTypes/layoutView/layoutView.schema";

import Accordion from "@CubeComponents/html/accordion/materialUiAccordian/index";
import AccordionDetails from "@mui/material/AccordionDetails";
import AccordionSummary from "@mui/material/AccordionSummary";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";

function DesignViewerLayoutSetting({
  setLayoutSettingMenu,
  availableData,
  setAvailableData,
  addedData,
  setAddedData,
  HoopsViewer,
  updateData,
  onSaveCallback,
  setUpdateData,
}: any) {
  const { t } = useTranslation();
  const [zoomLevel, setZoomLevel] = useState<any>(null);

  useEffect(() => {
    if (updateData) {
      setZoomLevel(updateData.data.zoomLevel);
    }
  }, [updateData]);

  function panelHeader() {
    return (
      <div className="flex items-center gap-3 text-base font-bold text-[var(--primary-text)] ps-7">
        <IconComponent name="layoutsIcon" height="1.5rem" width="1.5rem" />
        <div>{t("Panels")}</div>
      </div>
    );
  }

  const panelsContent = () => (
    <DesignViewerLayoutSettingComponent
      availableData={availableData}
      setAvailableData={setAvailableData}
      addedData={addedData}
      setAddedData={setAddedData}
    />
  );

  const settingAccordion = () => (
    <div className="flex flex-col h-full overflow-auto">
      <div className="flex items-center py-5 ps-10 flex-none">
        <div className="pe-[3.2%]">{t("Layout Name")}</div>
        <div className="w-[36%]">
          <TextFieldComponent
            type="text"
            value={updateData.name}
            onChange={(args: any) => {
              setUpdateData({ ...updateData, name: args.target.value });
            }}
          />
        </div>
      </div>
      <div className="h-full overflow-hidden">
        <Accordion
          defaultExpanded
          className="h-full"
          sx={{
            "& .MuiCollapse-root": {
              display: "flex",
              overflow: "auto",
              height: "90%",
            },
          }}
        >
          <AccordionSummary expandIcon={<ExpandMoreIcon />}>{panelHeader()}</AccordionSummary>
          <AccordionDetails>{panelsContent()}</AccordionDetails>
        </Accordion>
      </div>
      {/* <div className="flex-auto">
         <Accordion defaultExpanded>
           <AccordionSummary expandIcon={<ExpandMoreIcon />}>
             {zoomHeader()}
           </AccordionSummary>
           <AccordionDetails>
             {zoomContent()}
           </AccordionDetails>
         </Accordion>
       </div> */}
      <div className="flex h-20 items-center justify-end gap-[2.4%] p-2.5 pe-[4%] flex-none">
        <ButtonComponent buttonType="borderButton" onClick={onCancel}>
          {t("Cancel")}
        </ButtonComponent>
        <ButtonComponent buttonType="gradientButton" onClick={onSave}>
          {t("Save")}
        </ButtonComponent>
      </div>
    </div>
  );
  async function onSave() {
    const addData: any[] = [];
    addedData.map((data: any) => {
      addData.push(...(Object.values(data)[0] as any).widgets);
    });
    updateData.data.sidebarLayout.addedData = addData;
    updateData.data.zoomLevel = zoomLevel;
    // stringify and parse to break refrence
    updateData.data.rcDock = JSON.parse(JSON.stringify(HoopsViewer.rcDockref.saveLayout()));
    const response = await axiosWrapper.post<UpdateViewResponse>(`${getBackendUrl()}/layoutView/updateView`, {
      updateData: {
        name: updateData.name,
        data: updateData.data,
      },
      id: updateData._id,
    });
    if (response.data.status) {
      onSaveCallback && onSaveCallback({ updateData });
    }
    setLayoutSettingMenu(false);
  }

  function onCancel() {
    setLayoutSettingMenu(false);
  }

  return (
    <div className="fixed inset-0 flex items-center justify-center bg-[rgb(25_32_72_/_50%)] z-[99]">
      <div className="absolute w-[52.2%] h-[86.5%] bg-[var(--surface-white)] text-[var(--primary-text)] min-w-[40.625rem] flex flex-col z-[100] overflow-hidden">
        <div className="flex items-center justify-between bg-[var(--surface-stroke-gradient-color1)] h-15 text-2xl font-bold px-10 py-3 sticky top-0 z-10">
          <div>{t("Layout Settings")}</div>
          <IconComponent name="close" height="1.5rem" width="1.5rem" onClick={onCancel} />
        </div>
        {settingAccordion()}
      </div>
    </div>
  );
}

export default DesignViewerLayoutSetting;
